export const types = {
  GET_CONTRIBUTION_AGGREGATES: 'GET_CONTRIBUTION_AGGREGATES',
  GET_CONTRIBUTION_AGGREGATES_SUCCESS: 'GET_CONTRIBUTION_AGGREGATES_SUCCESS',
  CLEAR_AGGREGATES: 'CLEAR_AGGREGATES',
};
